import { render, staticRenderFns } from "./DashboardTop.vue?vue&type=template&id=32a4575b&"
import script from "./DashboardTop.vue?vue&type=script&lang=js&"
export * from "./DashboardTop.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports